export default function About() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Tentang <span className="text-orange-600">Cobramas Production</span>
            </h2>
            <p className="text-base text-gray-700 mb-4 leading-relaxed">
              <strong>Cobramas Production</strong> adalah perusahaan produsen material bangunan berbahan beton yang telah berpengalaman melayani kebutuhan konstruksi di wilayah Boyolali dan sekitarnya. Kami berkomitmen menghadirkan produk beton pracetak berkualitas tinggi dengan standar presisi dan kekuatan yang terjamin.
            </p>
            <p className="text-base text-gray-700 mb-4 leading-relaxed">
              Dengan fasilitas produksi modern dan tim profesional yang berpengalaman, kami memproduksi berbagai jenis material bangunan seperti <strong>batako</strong>, <strong>paving block</strong>, <strong>roster beton</strong>, <strong>kanstin</strong>, dan produk beton pracetak lainnya yang siap mendukung proyek rumah tinggal, ruko, gudang, hingga infrastruktur skala besar.
            </p>
            <p className="text-base text-gray-700 mb-6 leading-relaxed">
              Kepercayaan pelanggan adalah prioritas utama kami. Oleh karena itu, setiap produk yang kami hasilkan melalui proses quality control ketat untuk memastikan ketepatan ukuran, kekuatan struktur, dan daya tahan jangka panjang. Kami juga menawarkan harga yang kompetitif tanpa mengorbankan kualitas produk.
            </p>
            <div className="flex flex-wrap gap-4">
              <div className="flex items-center gap-2">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
                  <i className="ri-shield-check-line text-2xl text-orange-600"></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-gray-900">Kualitas Terjamin</p>
                  <p className="text-xs text-gray-600">Standar SNI</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
                  <i className="ri-time-line text-2xl text-orange-600"></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-gray-900">Pengiriman Tepat</p>
                  <p className="text-xs text-gray-600">Sesuai Jadwal</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="relative h-96 w-full rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/71ef41b3af730a6953f5eabde7c54181.jpeg"
                alt="Fasilitas Produksi Cobramas"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-orange-600 text-white p-6 rounded-xl shadow-xl">
              <p className="text-3xl font-bold">1985</p>
              <p className="text-sm">Berdiri Sejak</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}